export default "__VITE_PUBLIC_ASSET__e1907140__"